import { BonusHandlingEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/bonus-handling.enum";
import { UserFieldEntityTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/user-field-entity-type.enum";

export const BONUS_HANDLING_OPTIONS = [
  { label: 'Línea gratuita separada', value: BonusHandlingEnum.SEPARATE_FREE_LINE },
  { label: 'Incluida en posición con recálculo de precio', value: BonusHandlingEnum.INCLUDED_WITH_PRICE_RECALCULATION },
  { label: 'Incluida en posición sin recálculo de precio', value: BonusHandlingEnum.INCLUDED_WITHOUT_PRICE_RECALCULATION },
  { label: 'Bonificación incluida en posición con descuento', value: BonusHandlingEnum.INCLUDED_AS_DISCOUNT },
];

export const USER_FIELD_ENTITY_LIST = [
  { label: 'Socio de Negocios', value: UserFieldEntityTypeEnum.BUSINESS_PARTNER },
  { label: 'Cadena de Distribución de socio de negocios', value: UserFieldEntityTypeEnum.BP_DISTRIBUTION_CHAIN },
  { label: 'Material', value: UserFieldEntityTypeEnum.MATERIAL },
  { label: 'Cadena de Distribución de materiales', value: UserFieldEntityTypeEnum.MATERIAL_DISTRIBUTION_CHAIN },
];